import { render, staticRenderFns } from "./EmploeCard.vue?vue&type=template&id=59bb3e84&scoped=true&"
import script from "./EmploeCard.vue?vue&type=script&lang=js&"
export * from "./EmploeCard.vue?vue&type=script&lang=js&"
import style0 from "./EmploeCard.vue?vue&type=style&index=0&id=59bb3e84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bb3e84",
  null
  
)

export default component.exports